// extracted by mini-css-extract-plugin
export default {"badge":"alert-badge_badge__Dxx01"};